import { QAppsCountCard } from '@kw/quokka-ui';
import { createSearchParams, useNavigate } from 'react-router-dom';
import { Box } from '@mui/material';
import { DashboardAnalyticsDateRangeDays, DashboardAnalyticsMetrics, rollingSubmittedDateRange } from './dashboardAnalytics';

type AppInventoryProps = {
  dateRangeDays: DashboardAnalyticsDateRangeDays;
  metrics: DashboardAnalyticsMetrics | null | undefined;
};

export const AppInventory = ({ dateRangeDays, metrics }: AppInventoryProps) => {
  const navigate = useNavigate();

  const navigateToApplications = (platform: 'all' | 'android' | 'ios') => {
    const { startDate, endDate } = rollingSubmittedDateRange(dateRangeDays);
    navigate({
      pathname: '/applications',
      search: createSearchParams({
        platform,
        startDate,
        endDate,
      }).toString(),
    });
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'nowrap',
        gap: '24px',
        alignItems: 'stretch',
      }}
    >
      <QAppsCountCard
        data-testid="total-versions-card"
        variant="total"
        versionsCount={metrics?.totalVersionsAll}
        uniqueAppsCount={metrics?.uniqueAppsAll}
        onClick={() => navigateToApplications('all')}
        sx={{
          marginLeft: '0px',
        }}
      />
      <QAppsCountCard
        data-testid="android-versions-card"
        variant="android"
        versionsCount={metrics?.totalVersionsAndroid}
        uniqueAppsCount={metrics?.uniqueAppsAndroid}
        onClick={() => navigateToApplications('android')}
      />
      <QAppsCountCard
        data-testid="ios-versions-card"
        variant="ios"
        versionsCount={metrics?.totalVersionsIos}
        uniqueAppsCount={metrics?.uniqueAppsIos}
        onClick={() => navigateToApplications('ios')}
      />
    </Box>
  );
};
